import { SearchModes } from '@/domainLogic/index.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import analyticsResultClicked from '@/app/components/search/Analytics/analyticsResultClicked.ts';
import type { StarTrack } from '@/app/common/starTrack/startrack.ts';
import { createResultClickedPayload } from '@/app/common/starTrack/events/resultClicked.ts';
import type { CommonData } from '@/app/common/createCommonData.ts';
import { SDPRedirectEvent } from './ListContainer/CardsGrid/SDPRedirectEvent';
import type { Localization } from '../../common/Localization';
import type { CuriosityParams } from '../../Curiosity';
import type { DealCard } from '../../utils/buildDealCards/dealCardTypes';
import getSearchParams from '../../common/getSearchParams';

export enum CARD_TYPE {
  LIST = 'LIST',
  MAP = 'MAP',
}

const CTA_CARD = {
  [CARD_TYPE.LIST]: {
    [SearchModes.DP]: 'card-dp',
    [SearchModes.HO]: 'card-hotel',
  },
  [CARD_TYPE.MAP]: {
    [SearchModes.DP]: 'box-map-dp',
    [SearchModes.HO]: 'box-map-hotel',
  },
};

const CTA_CARD_HORIZONTAL = {
  [SearchModes.DP]: 'card-horizontal-dp',
  [SearchModes.HO]: 'card-horizontal-hotel',
};

type ResultClickedEvents = {
  starTrack: StarTrack;
  cardType: CARD_TYPE;
  dealCard?: DealCard;
  clickId: string;
  vcSearchId?: string;
  commonData: CommonData;
  localization: Localization;
  curiosityParams: CuriosityParams;
  checkMobile?: boolean;
};

// This method is just being used for Event logging now. See handleHotelChosen in PageWrapperClient for displaying the detail card
export const resultClickedEvents = ({
  starTrack,
  cardType,
  dealCard,
  clickId,
  vcSearchId,
  commonData,
  localization,
  curiosityParams,
  checkMobile,
}: ResultClickedEvents) => {
  const { currency } = localization;
  const { isMobileDevice } = commonData;
  const searchParams = getSearchParams();
  const searchModeToUse =
    searchParams.searchMode === SearchModes.DP || searchParams.searchMode === SearchModes.TH
      ? SearchModes.DP
      : SearchModes.HO;

  if (dealCard && !dealCard?.product?.dates?.soldOut) {
    SDPRedirectEvent({
      commonData,
      localization,
      curiosityParams,
      dealCard,
      currency,
      searchId: searchParams[URLParameters.SEARCH_ID],
    });
  }

  if (dealCard) {
    const ctaName =
      checkMobile && isMobileDevice ? CTA_CARD_HORIZONTAL[searchModeToUse] : CTA_CARD[cardType][searchModeToUse];

    starTrack.resultClicked(
      createResultClickedPayload({ searchParams, dealCard, clickId, vcSearchId, localization, ctaName })
    );

    analyticsResultClicked({ searchParams, dealCard, clickId, ctaName });
  }
};
